/* eslint-disable*/
import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Backdrop from "@mui/material/Backdrop";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import CheckIcon from "@mui/icons-material/Check";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { Box, Button, CircularProgress } from "@mui/material";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import {
  ChangeMasterFileAPI,
  SaleForceUploadFile,
  SharePointFolder,
} from "../services/apigateway";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import RequiredUploadDocuments from "../components/UploadDocuments/RequiredUploadDocuments";
import dayjs from "dayjs";
import helper from "../services/helper";

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  fontWeight: "bold",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundImage:
      "linear-gradient(0deg, rgba(184,0,200,1) 0%, rgba(161,0,175,1) 43%, rgba(184,0,200,1) 100%);",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundImage:
      "linear-gradient(0deg, rgba(184,0,200,1) 0%, rgba(161,0,175,1) 43%, rgba(184,0,200,1) 100%);",
  }),
}));

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient(0deg, rgba(184,0,200,1) 0%, rgba(161,0,175,1) 43%, rgba(184,0,200,1) 100%);",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient(0deg, rgba(184,0,200,1) 0%, rgba(161,0,175,1) 43%, rgba(184,0,200,1) 100%);",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 5,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
}));

function ColorlibStepIcon(props) {
  let { completed } = props;

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed }}
      style={{
        color: "white",
        backgroundColor: "rgba(184,0,200,1)",
        border: "1px solid #b5b5b5",
      }}
    >
      {completed ? <CheckIcon /> : <>{props.icon}</>}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

export default function UploadDocumentScreen() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [objChangeMasterFile, setObjChangeMasterFile] = React.useState({});
  const [showTableOther, setShowTableOther] = React.useState(false);
  const [showTableOtherAudited, setShowTableOtherAudited] =
    React.useState(false);
  const [isEdited, setIsEdited] = React.useState(false);
  const [companyName, setCompanyName] = React.useState("");
  const [pathsSharePoint, setPathsSharePoint] = React.useState([]);

  const [selectedOther, setSelectedOther] = React.useState([]);
  const [selectedAudited, setSelectedAudited] = React.useState([]);
  const [selectedCOI, setSelectedCOI] = React.useState([]);
  const [selectedMOA, setSelectedMOA] = React.useState([]);
  const [selectedRegVat, setSelectedRegVat] = React.useState([]);
  const [selectedListShareHold, setSelectedListShareHold] = React.useState([]);
  const [selectedMOE, setSelectedMOE] = React.useState([]);

  React.useEffect(() => {
    setActiveStep(0);
    const element = document.querySelector(".MuiStepLabel-iconContainer");
    if (element) {
      const elementText = document.querySelector(".css-1am1g1a");
      if (elementText) {
        elementText.textContent = "3";
      }
    }

    // Call your RequestForm function here
    const fetchData = async () => {
      try {
        setLoading(true);
        if (id) {
          const response = await SharePointFolder.getPathByAccount(id);
          const responseMaster =
            await ChangeMasterFileAPI.getChangeMasterFilelist(id);

          const filesSharePoint = response.responseData;

          if (responseMaster) {
            setIsEdited(
              responseMaster && responseMaster.records.length > 0 ? true : false
            );
          }

          const userInfo = helper.Auth.getTokenData();

          let company = userInfo.accounts.find((item) => item.Id === id);
          if (company) {
            setCompanyName(company.Name);
          }

          const mappedFiles = {
            Account_Common_CTR_Financial: [],
            Account_Common_CTR_COI: [],
            Account_Common_CTR_MOA: [],
            Account_Common_CTR_VAT_Reg: [],
            Account_Common_CTR_List_Sharehold: [],
            Account_Common_CTR_Reg_by_MoE: [],
            Account_Common_CTR_Others: [],
          };

          filesSharePoint.forEach((folder) => {
            if (mappedFiles.hasOwnProperty(folder.Name)) {
              mappedFiles[folder.Name] = folder.Path || [];
            }
          });
          setPathsSharePoint(mappedFiles);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const uploadFileToSaleForceAttachment = async (file) => {
    try {
      const uploadResponse = await SaleForceUploadFile.uploadChangeMasterFile(
        id,
        file
      );
      return uploadResponse;
    } catch (error) {
      console.error("Error while uploading:", error);
      if (error.response) {
        console.error("Response:", error.response);
      }
    }
  };

  const uploadFileToSharepoint = async (file, namefolder) => {
    try {
      if (file && namefolder) {
        let uploadResponse = await SharePointFolder.uploadFile(
          namefolder,
          [file],
          id
        );
        // console.log("Upload SP financial res:", uploadResponse);

        // Check if upload failed && ให้หยุดการทำงานของฟังก์ชั่นทุกอย่างทันที
        if (!uploadResponse || uploadResponse.error || uploadResponse.message === 'error' || uploadResponse.message === 'Upload failed') {
          Swal.fire({
            title: "Upload Failed",
            text: "Upload failed. Please try again or contact your administrator.",
            icon: "error",
            position: "center",
            showConfirmButton: true,
          }).then((res) => {
            if (res.isConfirmed) {
              window.location.reload();
            }
          });

          return false;
        }
        return true;
      }
    } catch (error) {
      console.error("Error while uploading:", error);
      if (error.response) {
        console.error("Response:", error.response);
      }
      Swal.fire({
        title: "Upload Failed",
        text: "Upload failed. Please try again or contact your administrator.",
        icon: "error",
        position: "center",
        showConfirmButton: true,
      }).then((res) => {
        if (res.isConfirmed) {
          window.location.reload();
        }
      });
      return false;
    }
  };

  const updateFiles = async () => {
    try {
      const fileInputs = [
        { id: "FileOther2", path: pathsSharePoint.Account_Common_CTR_Others },
        { id: "FileCOI2", path: pathsSharePoint.Account_Common_CTR_COI },
        { id: "FileMOA2", path: pathsSharePoint.Account_Common_CTR_MOA },
        { id: "FileRegVat2", path: pathsSharePoint.Account_Common_CTR_VAT_Reg },
        {
          id: "FileListShareHold2",
          path: pathsSharePoint.Account_Common_CTR_List_Sharehold,
        },
        {
          id: "FileListMOE2",
          path: pathsSharePoint.Account_Common_CTR_Reg_by_MoE,
        },
        {
          id: "FileOther2Audited",
          path: pathsSharePoint.Account_Common_CTR_Financial,
        },
      ];

      // Function to rename and upload files
      const processFiles = async (fileInput) => {
        const fileElement = document.getElementById(fileInput.id);
        if (!fileElement || fileElement.files.length === 0) return [];

        for (const file of fileElement.files) {
          const timestamp = dayjs().format("YYYYMMDD_HHmmss");
          const renamedFile = new File(
            [file],
            `${file.name.replace(/\.[^/.]+$/, "")}_${timestamp}.${file.name
              .split(".")
              .pop()}`,
            { type: file.type }
          );

          const uploadResult = await uploadFileToSharepoint(renamedFile, fileInput.path);

          // ถ้า upload ไม่สำเร็จ ให้หยุดทันที และ throw error
          if (uploadResult === false) {
            throw new Error("Upload failed");
          }
        }

        return Array.from(fileElement.files).map((file) => {
          const timestamp = dayjs().format("YYYYMMDD_HHmmss");
          return {
            name: `${file.name.replace(/\.[^/.]+$/, "")}_${timestamp}.${file.name.split(".").pop()}`,
            type: fileInput.path.split(".").pop(),
          };
        });
      };

      // Process all file inputs and Upload summary to Salesforce ##__ChangeMasterFiles__##
      const allFilesExist = await checkFilesExist();
      const masterChangeFileList = (
        await Promise.all(fileInputs.map(processFiles))
      ).flat();
      console.log(masterChangeFileList);

      if (allFilesExist) {
        if (masterChangeFileList.length > 0) {
          // await uploadFileToSaleForceAttachment(masterChangeFileList);
        }
      }

      // Clear input values
      document.getElementById("FileOther2").value = "";
      document.getElementById("FileOther2Audited").value = "";

      // Hide tables
      setShowTableOther(false);
      setShowTableOtherAudited(false);

      return true;
    } catch (error) {
      console.error("Error in handling file upload:", error);
      return false;
    }
  };

  const handleSubmitFiles = async function () {
    try {
      setLoading(true);

      // แสดง Dialog ยืนยันการอัพโหลด
      const result = await Swal.fire({
        title: "Do you want to confirm to upload the files?",
        text: "Please be aware that once the file is uploaded, it cannot be deleted.",
        icon: "question",
        position: "center",
        showDenyButton: true,
        confirmButtonText: "Yes",
        denyButtonText: "Cancel",
        cancelButtonColor: "red",
      });

      if (result.isConfirmed) {
        let resChecks = await updateFiles(); // อัพโหลดไฟล์ไปยัง SharePoint

        await Swal.fire({
          title: resChecks ? "Upload Complete" : "Upload Fail",
          icon: resChecks ? "success" : "error",
          showConfirmButton: true,
        })

        // Redirect ตามเงื่อนไขของการอัพโหลด
        if (resChecks) {
          navigate("/main");
        }

        // รีเซ็ตค่า
        document.getElementById("check-form-data-register-save-draft").click();
        setSelectedOther([]);
        setSelectedAudited([]);
        setSelectedCOI([]);
        setSelectedMOA([]);
        setSelectedRegVat([]);
        setSelectedListShareHold([]);
        setSelectedMOE([]);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error in handling form submission:", error);
    }
  };


  const checkFilesExist = async () => {
    const fileInputs = [
      { id: "FileOther2Audited", label: "FileOther2Audited" },
      { id: "FileOther2", label: "FileOther2" },
      { id: "FileCOI2", label: "FileCOI2" },
      { id: "FileMOA2", label: "FileMOA2" },
      { id: "FileRegVat2", label: "FileRegVat2" },
      { id: "FileListShareHold2", label: "FileListShareHold2" },
      { id: "FileListMOE2", label: "FileListMOE2" },
    ];

    let filesExist = [];
    // let missingFiles = [];

    fileInputs.forEach((input) => {
      const fileInputElement = document.getElementById(input.id);
      if (fileInputElement.files.length > 0) {
        Array.from(fileInputElement.files).forEach((file) =>
          filesExist.push(file.name)
        );
      }
      // else {
      //   missingFiles.push(
      //     input.id === "FileOther2Audited"
      //       ? "Financial Statements"
      //       : "Other Documents" || ""
      //   );
      // }
    });

    // if (filesExist.length > 0 && missingFiles.length === 0) {
    //   Swal.fire({
    //     title: "Notice",
    //     text: "Selected files: " + filesExist.join(", "),
    //     icon: "info",
    //     position: "center",
    //     confirmButtonText: "OK",
    //   });
    // }

    // if (missingFiles.length > 0) {
    //   Swal.fire({
    //     title: "Warning",
    //     text: "ไฟล์ในหัวข้อ " + missingFiles.join(", ") + " ยังไม่ได้เลือก",
    //     icon: "warning",
    //     position: "center",
    //     confirmButtonText: "OK",
    //   });
    // }

    // return filesExist.length > 0 && missingFiles.length === 0;
    return filesExist.length > 0;
  };

  const renderRequirmentScreen = (edit) => {
    return (
      <RequiredUploadDocuments
        isEdited={edit}
        objChangeMasterFile={objChangeMasterFile}
        setShowTableOther={setShowTableOther}
        setShowTableOtherAudited={setShowTableOtherAudited}
        setObjChangeMasterFile={setObjChangeMasterFile}
        setSelectedOther={setSelectedOther}
        setSelectedAudited={setSelectedAudited}
        setSelectedCOI={setSelectedCOI}
        setSelectedMOA={setSelectedMOA}
        setSelectedRegVat={setSelectedRegVat}
        setSelectedListShareHold={setSelectedListShareHold}
        setSelectedMOE={setSelectedMOE}
        selectedOther={selectedOther}
        selectedAudited={selectedAudited}
        selectedCOI={selectedCOI}
        selectedMOA={selectedMOA}
        selectedRegVat={selectedRegVat}
        selectedListShareHold={selectedListShareHold}
        selectedMOE={selectedMOE}
      />
    );
  };

  return (
    <>
      <Stack sx={{ width: "100%", margin: 5 }} spacing={4}>
        {/* steper */}
        <Stepper alternativeLabel connector={<ColorlibConnector />}>
          <Step>
            {!loading && (
              <Box display="flex" justifyContent="center" width="100%">
                <label style={{ fontWeight: "bold" }}>{companyName}</label>
              </Box>
            )}
            <br />
            <StepLabel StepIconComponent={ColorlibStepIcon}>
              Documents List and Upload
            </StepLabel>
          </Step>
        </Stepper>

        {/* render upload file list */}
        <Box>{renderRequirmentScreen(isEdited)}</Box>

        {/* button-upload-submit */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          {loading && (
            <Backdrop sx={{ color: "#fff", zIndex: 2 }} open={true}>
              <span
                style={{
                  justifyContent: "center",
                  position: "fixed",
                  top: "40%",
                }}
              >
                <Box
                  sx={{
                    p: 2,
                    m: 2,
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  <CircularProgress
                    style={{
                      width: 100,
                      height: 100,
                      color: "rgba(184,0,200,1)",
                    }}
                  />
                </Box>
                <Box sx={{ justifyContent: "center", display: "flex" }}>
                  <label style={{ fontSize: 22, fontWeight: "bold" }}>
                    {" "}
                    Please wait...
                  </label>
                </Box>
              </span>
            </Backdrop>
          )}
          {/* cancel */}
          <Button
            sx={{ p: 1, m: 1 }}
            variant="outlined"
            onClick={() => {
              Swal.fire({
                title: "Do you want to leave this page?",
                icon: "question",
                position: "center",
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: "Yes",
              }).then((result) => {
                if (result.isConfirmed) {
                  navigate(-1);
                }
              });
            }}
            style={{
              backgroundColor: "#fff",
              color: "#757575",
              borderColor: "gray",
            }}
          >
            Cancel
          </Button>
          {/* submit */}
          <Button
            sx={{ p: 1, m: 1 }}
            variant="contained"
            disabled={loading}
            onClick={() => {
              handleSubmitFiles();
            }}
            style={{ backgroundColor: "#2C88D9", color: "white" }}
          >
            <label style={{ paddingLeft: 4, paddingRight: 4 }}>
              Upload documents
            </label>
          </Button>
        </Box>
      </Stack>
    </>
  );
}
